import { useEffect } from "react";

/**
 * React hook to execute a callback function on click outside of the container
 *
 * @param {*} ref - ref to container element. Should be a DOM Node.
 * @param {*} callback -
 */
const useOuterClickEffect = (
  ref: React.RefObject<HTMLElement>,
  callback: Function
) => {
  useEffect(() => {
    if (ref != null) {
      const windowClick = (e: any) => {
        const node = ref.current;

        if (!node?.contains(e.target)) {
          callback(e);
        }
      };
      window.addEventListener("mousedown", windowClick, true);

      return () => {
        window.removeEventListener("mousedown", windowClick, true);
      };
    }
  });
};

export default useOuterClickEffect;
